import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Col } from 'react-bootstrap';
import { trimLowerCase } from '../../../helpers/shared';
import { Input } from '../../shared/Input';
import {
  useDisabled,
  useTextLanguage
} from '../../../hooks/useShared';
import { useEdit } from '../../../hooks/useEdit'
import { useTextInput } from '../../../hooks/useInput'
import { useAutocompleteDocuments } from '../../../hooks/useAutocompleteDocuments';
import { maskedMinLengthFields, maskedPhones } from '../../../constants/form';

/**
 * Component text input
 * @component
 * @param {Object} field
 * @returns
 */
export const TextInput = ({ field, entryProps ='', isGroup='' }) => {
  const uniqueName = `${field.unique_name}__id__${field.id}`;
  const { description, languageText } = useTextLanguage();
  const { register, formState: { errors }, setValue } = useFormContext();
  const { type, maskLength, validate } = useTextInput(field, uniqueName, isGroup);
  const { isDisabled } = useDisabled(field);
  const { colSize } = useEdit(field);
  useAutocompleteDocuments(field, uniqueName)

  return (
    <>
      {field && (
        <>
          {(colSize?.includes('col-before')) && (
            <Col xs={12} key={ `col_before_${field.id}` }></Col>
          )}
          <Col
            className={ colSize }
            data-module={ `module-${field.category?.field_category}` }
            data-name={ uniqueName }
            id={ `group_field_${field.id}` }
            key={ field.id }
            xs={12}
          >
            <Input
              autoComplete="off"
              className="w-100"
              disabled={ isDisabled }
              field={ field }
              id={ trimLowerCase(field.id) }
              isRequiredInput={ field.required }
              label={ field[description] }
              message={ errors?.[uniqueName]?.message }
              name={ register(uniqueName).name }
              placeholder={ field[`placeholder${languageText}`] }
              register={ register(uniqueName, {
                setValueAs: val => {
                  if (typeof val === 'string' && val !== 'hidden_field' && val !== 'hidden_rn' && (
                    maskedMinLengthFields.some((maskedField) => uniqueName.startsWith(maskedField)) ||
                    maskedPhones.some((maskedField) => uniqueName.startsWith(maskedField))
                  )
                  ) {
                    return val.replaceAll('-', '')?.replaceAll('_', '')
                              ?.replaceAll('(', '')?.replaceAll(')', '')
                  } else return val
                }
              }) }
              setValue={ setValue }
              tooltipText={ field[`tooltip${languageText}`] }
              type={ type }
              entryProps={entryProps}
              maskLength={maskLength}
              validate={validate}
            />
          </Col>
        </>
      )}
    </>
  );
};

TextInput.propTypes = {
  field: PropTypes.object.isRequired
};
